import React, { FC, HTMLAttributes } from 'react';
import styled from 'styled-components';
import { useResponsiveGlobalTokenValue } from '../useResponsiveGlobalTokenValue';

export interface PaddingProps extends HTMLAttributes<HTMLDivElement> {
  all?: boolean | number;
  horizontal?: boolean | number;
  vertical?: boolean | number;
  top?: boolean | number;
  right?: boolean | number;
  bottom?: boolean | number;
  left?: boolean | number;
  scrollable?: boolean;
}

export const Padding: FC<PaddingProps> = (props) => {
  const {
    all,
    horizontal,
    vertical,
    top,
    right,
    bottom,
    left,
    scrollable = false,
    ...rest
  } = props;
  const paddingPx = useResponsiveGlobalTokenValue('padding');

  if (all || (!horizontal && !vertical && !top && !right && !bottom && !left)) {
    return (
      <StyledPadding
        $padding={typeof all === 'number' ? all : paddingPx}
        $scrollable={scrollable}
        {...rest}
      />
    );
  }

  return (
    <StyledPadding
      $padding={[
        typeof top === 'number' ? top : top ? paddingPx : 0,
        typeof right === 'number' ? right : right ? paddingPx : 0,
        typeof bottom === 'number' ? bottom : bottom ? paddingPx : 0,
        typeof left === 'number' ? left : left ? paddingPx : 0,
      ]}
      $paddingInline={
        typeof horizontal === 'number'
          ? horizontal
          : horizontal
            ? paddingPx
            : undefined
      }
      $paddingBlock={
        typeof vertical === 'number'
          ? vertical
          : vertical
            ? paddingPx
            : undefined
      }
      $scrollable={scrollable}
      {...rest}
    />
  );
};

const StyledPadding = styled.div<{
  $padding: number | number[];
  $paddingInline?: number;
  $paddingBlock?: number;
  $scrollable: boolean;
}>`
  padding: ${({ $padding }) => toPx($padding)};
  ${({ $paddingInline }) =>
    $paddingInline ? `padding-inline: ${toPx($paddingInline)}` : ''};
  ${({ $paddingBlock }) =>
    $paddingBlock ? `padding-block: ${toPx($paddingBlock)}` : ''};

  ${({ $scrollable }) => ($scrollable ? 'overflow: auto;' : '')}
`;

const toPx = (value: number | number[]) =>
  [value]
    .flat()
    .map((v) => `${v}px`)
    .join(' ');
